import {
  IFetchAutoAssessmentsRequestsListData,
  IFormattedAutoAssessmentsRequestsListData,
} from '../types';

/**
 * Formats the auto assessments requests list API response data.
 */
export function formatAutoAssessmentsRequestsListResponse(
  response: IFetchAutoAssessmentsRequestsListData
): IFormattedAutoAssessmentsRequestsListData {
  const { requests, total } = response;

  const requestsList = Object.entries(requests).map(([title, items]) => {
    const formattedItems = items.map((item) => {
      const {
        _id: requestId,
        assetDetail,
        imageCount,
        sessionId,
        status,
        thumbnail,
        updatedDate,
        user,
      } = item;

      // eslint-disable-next-line camelcase
      const { _id: assetId, label, label_ar } = assetDetail;
      const { key, label: statusLabel, label_ar: statusLabelAr } = status;

      const assetDetailFormatted = {
        assetId,
        label: {
          en: label,
          // eslint-disable-next-line camelcase
          ar: label_ar || label,
        },
        labelStr: label,
      };

      const statusFormatted = {
        key,
        label: {
          en: statusLabel,
          ar: statusLabelAr || statusLabel,
        },
        labelStr: statusLabel,
      };

      return {
        requestId,
        assetDetail: assetDetailFormatted,
        sessionId,
        imageCount,
        status: statusFormatted,
        thumbnail,
        updatedDate,
        user,
      };
    });
    return { title, data: formattedItems };
  });

  return {
    requests: requestsList,
    total,
  };
}
